import { useMutation } from '@tanstack/react-query';
import { api } from '@/libs/axios/api';
import { apiConfig } from '@/config/api';

export const useSendSuggestionEvent = () => {
  return useMutation({
    mutationFn: sendSuggestionEvent,
  });
};

const sendSuggestionEvent = async (payload: { suggestion: string }) =>
  api.post(apiConfig.routes.suggestion.sendSuggestion, payload);
